<template>
    <transition name="fade">
        <div>
            <img class="Terms-logoPrivacyPolitics" ref="logo" src="@/assets/img/logo.svg" alt="Carta Blanca" />
            <!-- <div class="Terms-close" @click="$emit('close')" /> -->
            <article class="TermsTextPrivacyPolitics" id="privacy-policy" v-html="privacy"></article>
        </div>
    </transition>
</template>

<script>

export default {
    data() {
        return {
            privacy: "",
        };
    },

    async mounted() {
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = () => {
            if (xhttp.readyState == 4 && xhttp.status == 200) {
                this.privacy = xhttp.responseText
                    .replace("{", "")
                    .replace('"body":"', "")
                    .replace('";', "")
                    .replace("}", "");
            }
        };
        xhttp.open(
            "GET",
            "https://api-mx-marketing.azure-api.net/sitios/privacidad/aviso" +
            "?ref=" +
            Math.random() * 9999,
            true,
        );
        xhttp.send();
    },
    props: {
        visible: {
            type: Boolean,
        },
    },
}
</script>

<style lang="css" >
.Terms-logoPrivacyPolitics {
    width: 85px;
    position: absolute 40px 30px;
}


.TermsTextPrivacyPolitics {
    margin-bottom: 30px;
    text-align: justify;
    max-width: 960px;
    margin: 0 auto;
    color: #464646;
    width: 75vw;
}

.TermsTextPrivacyPolitics>div>table {
    width: 100% !important;
    border-collapse: collapse !important;
    border-collapse: collapse;
    border-spacing: 0;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 2.5rem 0;
    overflow: auto;
    padding: 1rem
}

.TermsTextPrivacyPolitics th,
td,
tr {
    border: 1px solid;
    font-size: 1.2vw !important;
    padding: 5px;
}

.TermsTextPrivacyPolitics h2,
h3,
p {
    margin: 0;
}

.TermsTextPrivacyPolitics 
p {
    font-size: 19px;
}

.TermsTextPrivacyPolitics
h3 {
    text-transform: uppercase;
}

.TermsTextPrivacyPolitics h2 {
    font-size: 1.3em !important;
    font-weight: 900;
    line-height: 1.2em;
    margin-bottom: 1em;
    color: WESTAR;
}

.TermsTextPrivacyPolitics h3 {
    letter-spacing: 0.1em;
}

.TermsTextPrivacyPolitics h4 {
    font-size: 19px;
}

.TermsTextPrivacyPolitics p {
    margin-bottom: 1.5em;
    font-size: 19px;
}
</style>